export const membershiptranscation = [
  {
    id: "MT156328",
    providerName: "GreenValleyHighSchool",
    planType: "Starter",
    transactionDate: "25Apr2024",
    amount: "$99",
    paymentMethod: "Cash",
    startDate: "25Apr2024",
    endDate: "24May2024",
    status: "Completed",
    key:1
  },
  {
    id: "MT156327",
    providerName: "RiversideAcademy",
    planType: "Enterprise",
    transactionDate: "29Apr2024",
    amount: "$149",
    paymentMethod: "Credit",
    startDate: "29Apr2024",
    endDate: "28May2024",
    status: "Completed",
    key:2
  },
  {
    id: "MT156326",
    providerName: "SunshineSchool",
    planType: "Starter",
    transactionDate: "03May2024",
    amount: "$99",
    paymentMethod: "Cash",
    startDate: "03May2024",
    endDate: "02Jun2024",
    status: "Completed",
    key:3
  },
  {
    id: "MT156325",
    providerName: "MaplewoodHighSchool",
    planType: "Premium",
    transactionDate: "15May2024",
    amount: "$199",
    paymentMethod: "Cash",
    startDate: "15May2024",
    endDate: "14Jun2024",
    status: "Completed",
    key:4
  },
  {
    id: "MT156324",
    providerName: "MountainHighSchool",
    planType: "Enterprise",
    transactionDate: "15May2024",
    amount: "$149",
    paymentMethod: "Cash",
    startDate: "25May2024",
    endDate: "24Jun2024",
    status: "Completed",
    key:5
  },
  {
    id: "MT156323",
    providerName: "HillsideElementarySchool",
    planType: "Starter",
    transactionDate: "12Jun2024",
    amount: "$99",
    paymentMethod: "Credit",
    startDate: "12Jun2024",
    endDate: "11Jul2024",
    status: "Pending",
    key:6
  },
  {
    id: "MT156322",
    providerName: "WillowCreekHighSchool",
    planType: "Starter",
    transactionDate: "17Jun2024",
    amount: "$99",
    paymentMethod: "Cash",
    startDate: "17Jun2024",
    endDate: "16Jul2024",
    status: "Completed",
    key:7
  },
  {
    id: "MT156321",
    providerName: "BrooksideHighSchool",
    planType: "Premium",
    transactionDate: "26Jun2024",
    amount: "$199",
    paymentMethod: "Cash",
    startDate: "26Jun2024",
    endDate: "25Jul2024",
    status: "Pending",
    key:8
  },
  {
    id: "MT156320",
    providerName: "CedarGroveAcademy",
    planType: "Enterprise",
    transactionDate: "03Jul2024",
    amount: "$149",
    paymentMethod: "Cash",
    startDate: "03Jul2024",
    endDate: "02Aug2024",
    status: "Completed",
    key:9
  },
  {
    id: "MT156319",
    providerName: "WestfieldElementarySchool",
    planType: "Starter",
    transactionDate: "12Jul2024",
    amount: "$99",
    paymentMethod: "Cash",
    startDate: "12Jul2024",
    endDate: "11Aug2024",
    status: "Completed",
    key:10
  },
];
